import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import { paramToSlug } from '../../utils';

interface PayorNameProps {
	payorFirstName: string;
	payorLastName: string;
	isEditMode: boolean;
	setPayorFirstName: (value: string) => void;
	setPayorLastName: (value: string) => void;
	setHasUnsavedChanges: (value: boolean) => void;
}

export const PayorName = ({
	payorFirstName,
	payorLastName,
	isEditMode,
	setPayorFirstName,
	setPayorLastName,
	setHasUnsavedChanges,
}: PayorNameProps) => {
	const nameFields = [
		{ label: 'First Name', value: payorFirstName, setterFunction: setPayorFirstName },
		{ label: 'Last Name', value: payorLastName, setterFunction: setPayorLastName },
	];

	if (isEditMode) {
		return (
			<>
				{nameFields.map(({ label, value, setterFunction }) => (
					<Grid item key={label} xs>
						<TextField
							required
							id={`name-${label}`}
							label={label}
							fullWidth
							value={value || ''}
							onChange={(e) => {
								setHasUnsavedChanges(true);
								setterFunction(e.target.value);
							}}
							InputProps={{
								readOnly: !isEditMode,
							}}
							inputProps={{
								'data-cy': `primary-contact-${paramToSlug(label)}-input`,
							}}
						/>
					</Grid>
				))}
			</>
		);
	}

	return (
		<Grid item xs>
			<TextField
				required
				id='name'
				label='Name'
				fullWidth
				value={`${payorFirstName} ${payorLastName}`}
				InputProps={{
					readOnly: !isEditMode,
				}}
			/>
		</Grid>
	);
};
